export const defaultLanguage = 'en'
export const cookieName = 'glovo_user_lang'
export const defaultNameSpace = 'default'

export const languages = [
  { code: 'bg', name: 'Български' },
  { code: 'bs', name: 'Bosanski' },
  { code: 'ca', name: 'Català' },
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'eu', name: 'Euskara' },
  { code: 'fr', name: 'Français' },
  { code: 'hr', name: 'Hrvatski' },
  { code: 'hy', name: 'Հայերեն' },
  { code: 'it', name: 'Italiano' },
  { code: 'ka', name: 'ქართული' },
  { code: 'kk', name: 'Қазақ' },
  { code: 'ky', name: 'Кыргызча' },
  { code: 'pl', name: 'Polski' },
  { code: 'pt', name: 'Português' },
  { code: 'ro', name: 'Română' },
  { code: 'ru', name: 'Русский' },
  { code: 'sl', name: 'Slovenščina' },
  { code: 'sr', name: 'Српски' },
  { code: 'uk', name: 'Українська' },
] as const

export const languageCodes = languages.map((language) => language.code)

export const localisationConfig = {
  supportedLngs: languageCodes,
  fallbackLng: defaultLanguage,
  fallbackNS: defaultNameSpace,
  interpolation: {
    prefix: '{',
    suffix: '}',
  },
}

export type Language = (typeof languageCodes)[number]
